/**
 * Helpers for native date/time inputs, which work in LOCAL time.
 * `new Date().toISOString()` is UTC, so we offset to local before slicing.
 */

/** Current local time as `YYYY-MM-DDTHH:MM` — for <input type="datetime-local"> value/min. */
export function nowLocalDatetime(): string {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

/** Current local time as `HH:MM` — for <input type="time"> value. */
export function nowLocalTime(): string {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(11, 16);
}

/** Today's local date as `YYYY-MM-DD` — for <input type="date"> min. */
export function todayLocalDate(): string {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}
